import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.FeeFreqEnumSortEnum>
) {
  const {
    pagination: { page, perPage },
    sort: { field, order },
  } = params;

  const {
    feeFreqEnumList: { items: data, total },
  } = await sdk.getListFeeFreqEnum({
    page: {
      offset: (page - 1) * perPage,
      limit: perPage,
    },
    sort: [{ field, order }],
  });

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { feeFreqEnum: data } = await sdk.getOneFeeFreqEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(Number);

  const { feeFreqEnumMany: data } = await sdk.getManyFeeFreqEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const feeFreqEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
});
